import { IGrading } from '../types';

export enum GradingActionTypes {
    GET_GRADING = 'GET_GRADING',
    SAVE_GRADING = 'SAVE_GRADING',
}

export interface GradingAction {
    type: GradingActionTypes;
    payload: IGrading;
}
